// console.log('custom.js');

    var Swipes = new Swiper('.multi-column-slider1', {
      loop: false,
      navigation: {
      nextEl: '.swiper-button-next3',
      prevEl: '.swiper-button-prev3',
      },
      slidesPerView: 4,
      spaceBetween: 0,
      breakpoints: {
        500: {
        slidesPerView: 2.1
        },
        719: {
        slidesPerView: 2.1
        },
        1024: {
        slidesPerView: 4
        }
      }
});

var Swipes = new Swiper('.multi-column-slider', {
  loop: false,
  slidesPerView: 3,
  spaceBetween: 0,
  navigation: {
  nextEl: '.swiper-button-next2',
  prevEl: '.swiper-button-prev2',
  },
  breakpoints: {
    500: {
    slidesPerView: 2.1
    },
    719: {
    slidesPerView: 2.1
    },
    1024: {
    slidesPerView: 3
    }
  }
});